import { ActivityLogsProvider } from "@/references/context/ActivityLogs.tsx";
import { registerAppProvider } from "@/shared/bootstrap/react.tsx";

registerAppProvider(ActivityLogsProvider);
